import { render, staticRenderFns } from "./adminAdd.vue?vue&type=template&id=52f6fd5a&scoped=true"
import script from "./adminAdd.vue?vue&type=script&lang=js"
export * from "./adminAdd.vue?vue&type=script&lang=js"
import style0 from "./adminAdd.vue?vue&type=style&index=0&id=52f6fd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6fd5a",
  null
  
)

export default component.exports